import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";
import styled from "styled-components";
import { supabase } from "../../client";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import { useHistory } from "react-router";

const Cart = ({
  cart,
  setCart,
  addToCart,
  removeFromCart,
  emptyCart,
  details,
}) => {
  let total_quantity = 0;
  let total_price = 0;
  const history = useHistory();

  const Checkout = async () => {
    if (supabase.auth.user() && details.length) {
      const { data } = await supabase.from("orders").upsert({
        total_quantity: total_quantity,
        total_price: total_price,
        user_id: supabase.auth.user().id,
      });

      cart.items.map(async (item) => {
        await supabase.from("order_details").upsert({
          order_id: data[0].id,
          product_id: item.id,
          qty: item.qty,
          unit_price: item.price,
          total_price: item.qty * item.price,
        });
      });

      setCart({ items: [], qty: 0 });
      localStorage.removeItem("cart");
    } else {
      if (supabase.auth.user()) history.push("/dashboard/address");
      else history.push("/login");
    }
  };
  return (
    <LargeContainer>
      <MainContainer>
        <Right>
          <Heading>MY CART</Heading>
          {cart.items.length ? (
            <>
              {cart.items.map((e) => {
                total_price += e.qty * e.price;
                total_quantity += e.qty;

                return (
                  <OrderCard key={e.id}>
                    <ProductImage>
                      <img src={e.img} alt="p" />
                    </ProductImage>
                    <ProductName>{e.name}</ProductName>
                    <ProductQuantity>
                      <FaMinus onClick={() => removeFromCart(e)} />
                      {e.qty}
                      <FaPlus onClick={() => addToCart(e)} />
                    </ProductQuantity>
                    <Total>
                      ${(e.price * e.qty).toFixed(2)} for {e.qty} items
                    </Total>
                    <More>
                      <FaTrash onClick={() => emptyCart(e)} />
                    </More>
                  </OrderCard>
                );
              })}
              <OrderCard style={{ fontWeight: "500" }}>
                <ProductImage></ProductImage>
                <ProductName>Total</ProductName>
                <ProductQuantity>{total_quantity} Items</ProductQuantity>
                <Total>${total_price.toFixed(2)}</Total>
                <More></More>
              </OrderCard>
              <Button onClick={() => Checkout()}>Checkout</Button>
            </>
          ) : (
            <>
              <h1>Seems Soooo Empty!!!</h1>
              <h1>Add Something To Cart</h1>
            </>
          )}
        </Right>
      </MainContainer>
    </LargeContainer>
  );
};

const Right = styled.div`
  width: 100%;
  border: 1px solid #ddd;
  padding: 2em;
  margin: 1em; ;
`;

const Heading = styled.div`
  color: #525252;
  font-size: 1.3rem;
  font-weight: 500;
  margin-bottom: 1em;
`;
const OrderCard = styled.div`
  display: flex;
  width: 100%;
`;
const ProductImage = styled.div`
  width: 10%;
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  padding: 1em;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`;
const ProductName = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  padding: 1em;
  text-align: center;
`;
const ProductQuantity = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  padding: 1em;
  & > * {
    font-size: 1.3rem;
    border: 1px solid grey;
    cursor: pointer;
    padding: 0.2em;
    margin: 0 0.5em;
    transition: all 0.3s;
    :hover {
      background-color: #83aa4c;
      color: white;
    }
  }
`;
const Total = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  padding: 1em;
`;
const More = styled.div`
  border: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  padding: 1em;
  & > * {
    cursor: pointer;
    width: 100%;
    transition: color 0.3s;
    :hover {
      color: #83aa4c;
    }
    /* height: 2em; */
  }
`;
const Button = styled.button`
  width: 8em;
  border: none;
  align-self: flex-start;
  margin-top: 1em;
  padding: 1em 2em;
  background-color: #83aa4c;
  border-radius: 32px;
  color: white;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
  :hover {
    scale: 1.1;
  }
`;
export default Cart;
